/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { sendGTMSignUpEvent } from '@/data/events/handlers/gtm/SignUp';
import { GTMSignUpPayload } from '@/data/types/GTM';

type SignUpDelegatorProps = {
	gtm?: GTMSignUpPayload;
};

export const signUpDelegator = async (payload: SignUpDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMSignUpEvent(gtm);
	}
};
